'use strict';

common.View.create('website::partials.Menu', {
    onDOMLoad() {
        this.initMobileMenu();
    },

    initMobileMenu() {
        let hamburger = $('.hamburger');

        // Unbind and rebind, so we only register one event (this is the only way as of 25-08-2022
        hamburger.unbind('click').on('click', function () {
            let event = new CustomEvent('mobile-menu-update', {
                bubbles: true,
                detail: {
                    open: true,
                },
            });

            window.dispatchEvent(event);

            hamburger.addClass('is-active');
            $('body').addClass('overflow-hidden');
        });

        window.removeEventListener('mobile-menu-closed', this.menuClosedEvent);
        window.addEventListener('mobile-menu-closed', this.menuClosedEvent);
    },

    menuClosedEvent() {
        let hamburger = $('.hamburger');

        $('body').removeClass('overflow-hidden');

        setTimeout(() => {
            hamburger.removeClass('is-active');
        }, 350);
    },
});
